<script>
import formatCurrency from "@utils/format-currency";
import { prepaidFormatExpiredDate, prepaidFormatUsedTimes, prepaidHasInventory } from "@utils/ipetbooking-prepaid";
import { authComputed, merchantComputed } from "@store/helpers";
import formatPrice, { formatPriceRange } from "@utils/format-price";
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";

export default {
  props: {
    prepaidItem: {
      type: Object,
      default: () => {
        return {
          stores: [
            {
              name: "台北店",
              fullAddress: "新北市新莊區中正路542號",
              lat: 25.0542851,
              lng: 121.5609319
            }
          ],
          name: '迷你犬包套皮毛管理 (3kg以下)',
          times: 10
        }
      }
    },
    priceItem: {
      type: Object,
      default: () => {
        return {
          "title": "經典洗澡卡『深層潔淨』迷你型",
          "alias": "uc18fu7bggrtkg0yt9nh",
          "sizeTitle": "迷你犬（3kg以下）",
          "price": 2600
        }
      }
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    billList() {
      return [
        {
          title: `1${this.$globalIsDingBeauty ? '<i class="fontello fontello-db-lipstick fa-fw ml-2 text-primary"></i>': '<i class="fontello fontello-paw fa-fw ml-2 text-primary-dark"></i>'}`,
          text: `${
                this.priceItem.levelDiscount > 0 ?  
                `<span class=""> 
                  會員價：NT$ ${memberLevelPriceDiscount(this.priceItem.price, this.priceItem)}
                </span>
                <br>
                <span class="font-number text-decoration-line-through fs-2sm text-gray-2">售價：NT$ ${this.priceItem.price}</span>
                `
                : 
                this.priceItem.price
              }`,
          textClass: 'font-number'
        },
        {
          type: 'hr'
        },
        {
          title: '總計', 
          text: `${formatPrice(this.priceItem.levelDiscount > 0 
          ? memberLevelPriceDiscount(this.priceItem.price, this.priceItem)
          : this.priceItem.price)}`,
          class: 'align-items-end',
          textClass: this.$globalIsDingBeauty ? 'font-number fw-semi-bold fs-xl text-secondary' : 'text-primary-dark font-number fw-semi-bold fs-xl',
        },
      ]
    },
    prepaidType() {
      if(this.prepaidItem.alias.indexOf('dog') > 1) {
        return 'dog'
      }

      else if(this.prepaidItem.alias.indexOf('cat') > 1) {
        return 'cat'
      }

      else {
        return ''
      }
    },
  },
  methods: {
    prepaidHasInventory,
    prepaidFormatExpiredDate,
    prepaidFormatUsedTimes,
    formatPrice,
    formatPriceRange,
    memberLevelPriceDiscount,
    onSubmit() {
      const prepaidAlias = this.priceItem.alias;

      const loggedInFn = () => {
        this.$nextTick(() => {
          if(this.isBlock) {
            this.$globalDialog('DialogBlock', {})
            return
          }
          const loadingMaskCheckOutCart = this.$loading({
            lock: true,
            text: '正在前往結帳',
            spinner: `fal fa-circle-notch fa-spin`,
            background: 'rgba(81, 176, 202, 0.3)',
            customClass: 'isStyleCheckout'
          });

          this.tryToStoreCart({ prepaidAlias })
            .then(() => {
              const goToPrepaidCheckout = () => {
                this.$router.push({
                  name: 'prepaid-checkout',
                  params: {
                    prepaidAlias
                  }
                });
              };

              goToPrepaidCheckout()
            })
            .catch((e) => {
              if(e.status === 'STATUS_CODE_UNDEFINED') {
                this.$globalDialog('DialogBlock', {})
              }
            })
            .finally(() => {
              loadingMaskCheckOutCart.close()
            })
        });
      };

      if(this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        });
      }
    },
    onClickSelectSize() {
      this.$bus.$emit("infoBoxJtails:validateObserver");
      this.scrollToId('size')
    },
    scrollToId(id) {
      this.$scrollToElement({
        $el: document.getElementById(id),
        offset: 500,
      });
    },
    async tryToStoreCart({ prepaidAlias }) {
      await this.$store.dispatch('cart/storeCart', {
        prepaidAlias,
      })
        .then(() => {
          return true
        })
    },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.infoBoxJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <BaseStoreTagList
      :store-list="prepaidItem.stores"
      class="d-none d-md-flex"
    />
    <div class="infoBoxJtails__title">
      {{ prepaidItem.title }}
    </div>
    <div class="infoBoxJtails__info">
      <div v-if="$globalCategoryVisible">
        <i v-if="$globalIsDingBeauty" class="fontello fontello-db-lipstick fa-fw mr-2 text-primary"></i>
        <i v-else class="fontello fontello-db-lipstick fa-fw mr-2 text-gray-3"></i>
        <span>
          <span v-if="!$globalIsDingBeauty">{{$t('site.USER')}}：</span>
          <span>{{ prepaidItem.categoryTitle }}<span v-if="priceItem.sizeTitle"> | {{ priceItem.sizeTitle }}</span></span>
        </span>
      </div>
      <div>
        <i v-if="$globalIsDingBeauty" class="fontello fontello-calendar fa-fw mr-2 text-primary"></i>
        <i v-else class="fontello fontello-calendar fa-fw mr-2 text-gray-3"></i>
        <span>
          <span>總抵扣次數：</span>
          <span :title="prepaidItem.times">{{ prepaidFormatUsedTimes(prepaidItem.times) }}次</span>
        </span>
      </div>
      <div>
        <i v-if="$globalIsDingBeauty" class="fontello fontello-time fa-fw mr-2 text-primary"></i>
        <i v-else class="fontello fontello-time fa-fw mr-2 text-gray-3"></i>
        <span>
          <span>使用期限：</span>
          <span>{{ prepaidFormatExpiredDate(prepaidItem) }}</span>
        </span>
      </div>
    </div>
    <div class="mb-4 d-none d-md-block">
      <BaseList
        v-if="priceItem.price"
        :data-list="billList"
        type="bill"
      />
    </div>
    <div class="infoBoxJtails__mobile-info">
      <div class="infoBoxJtails__mobile-info__inner">
        <div class="infoBoxJtails__mobile-info__left">
          <span class="infoBoxJtails__mobile-info__title">
            <span class="font-number fw-medium">
              <template v-if="!!priceItem.alias">
                <template v-if="priceItem.levelDiscount > 0">
                  {{ formatPrice(memberLevelPriceDiscount(priceItem.price, priceItem)) }}
                  <span class="font-number text-decoration-line-through fs-2sm text-gray-2">NT$ {{ priceItem.price }}</span>
                </template>
                <template v-else>
                  {{ formatPrice(priceItem.price) }}
                </template>
                
              </template>
              <template v-else>
                {{ formatPriceRange(prepaidItem.minPrice, prepaidItem.maxPrice) }}
              </template>
            </span>
          </span>
          <span class="fs-2sm">
            <span>使用期限：</span>
            <span>{{ prepaidFormatExpiredDate(prepaidItem) }}</span>
          </span>
        </div>
        <template v-if="!currentMerchant.prepaidSetting.isEnabled">
          <BaseButton
            class="isStyleSecondary isFull"
            :class="{
              'isRadius': $globalIsJtails,
            }"
            disabled
          >
            尚未開放預約
          </BaseButton>
        </template>
        <BaseButton
          v-else-if="!priceItem.price"
          class="isStyleSecondary isFull"
          :class="{
            'isRadius': $globalIsJtails,
          }"
          @click="onClickSelectSize"
        >
          請選擇{{ $t('site.FORM_SIZE') }}
        </BaseButton>
        <BaseButton
          v-else-if="prepaidHasInventory(priceItem)"
          :loading="$isLoading('storeCart')"
          class="isStylePrimary isFull"
          :class="{
            'isRadius': $globalIsJtails,
          }"
          @click="onSubmit"
        >
          立即購買
        </BaseButton>
        <BaseButton
          v-else
          disabled
          class="isStylePrimary isOutline2 isFull"
          :class="{
            'isRadius': $globalIsJtails,
          }"
          style="pointer-events: none"
        >
          已售完
        </BaseButton>
      </div>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.infoBoxJtails {
  padding: 2.25rem 1.875rem;
  background: #FFF;
  box-shadow: 2px 8px 36px #1C2C5414;

  @include max-md {
    padding: 0.75rem $container-gap;
    padding-bottom: 0.75rem;
    padding-bottom: calc(0.75rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom));
    border-radius: 0;
    box-shadow: 0 -1px 4px #1C2C5414;
  }

  :global {
    .infoBoxJtails {
      &__title {
        margin-bottom: 1rem;
        font-size: 1.25rem;
        font-weight: 600;

        @extend %FontSerifWeightJtails;

        @include max-md {
          display: none;
        }
      }

      &__info {
        margin-bottom: 2rem;
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;

        @include max-md {
          display: none;
        }
      }

      &__mobile-info {
        &__inner {
          @include max-md {
            display: flex;
            justify-content: space-between;
          }
        }

        &__left {
          @include min-md {
            display: none;
          }
        }

        &__title {
          display: block;
          font-size: 1.1rem;
          line-height: 1;
        }

        .baseButton {
          @include max-md {
            width: auto;
            padding: 0.4rem 1.5rem;
            font-size: 0.875rem;
          }
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .infoBoxJtails {
        &__title{
          font-family: unset;
          color: $color-secondary;
          font-weight: 500;
        }
      }
      .fontello-db-lipstick {
        font-size: 1rem;
        position: relative;
        left: -2px;
      }
    }
  }
}
</style>
